interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  subtitle: string;
}

// Header editorial de sección: eyebrow con línea de 8px → título → subtítulo
export default function SectionHeader({
  eyebrow,
  title,
  subtitle,
}: SectionHeaderProps) {
  return (
    <div className="max-w-3xl mb-14">
      <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#102542] font-semibold mb-4">
        <span className="w-8 h-px bg-[#102542]" />
        {eyebrow}
      </span>
      <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 tracking-tight">
        {title}
      </h2>
      <p className="text-gray-600 text-base leading-relaxed">{subtitle}</p>
    </div>
  );
}
